<form [formGroup]="form">
  <mat-form-field>
    <input type="text" placeholder="Search" matInput formControlName="search" [matAutocomplete]="auto" appAutofocus>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)" [displayWith]="display">
      <mat-option *ngFor="let resource of resources | async" [value]="resource">
        {{ resource[field] }}
      </mat-option>
    </mat-autocomplete>
    <button *ngIf="clearable" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="optionCleared()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</form>
